/* Publish by EComposer at 2026-10-22 19:10:31*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-grq260nq7i6"]=  window.__ectimmers["ecom-grq260nq7i6"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-grq260nq7i6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-grq260nq7i6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ctclxe5q2r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ctclxe5q2r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z1hldxy3wc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z1hldxy3wc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t8p6aflww7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t8p6aflww7a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xxlm7hmljbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xxlm7hmljbk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s5w4ktfvmw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s5w4ktfvmw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-po960brlwls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-po960brlwls', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wh3qrmpf81i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wh3qrmpf81i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-apg4mcwjkea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-apg4mcwjkea', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a7vz83ac69u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a7vz83ac69u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m72s6od9g9b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m72s6od9g9b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s2tk5h6t868').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s2tk5h6t868', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sfk0ouu86h9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sfk0ouu86h9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g98ulsqiug9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g98ulsqiug9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dyclmw9oc6r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dyclmw9oc6r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aath50rg96r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aath50rg96r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pbhrxxeorcd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pbhrxxeorcd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c4xjtxnn42w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c4xjtxnn42w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ej98ewn8vt6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ej98ewn8vt6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mdkfuvpt35').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mdkfuvpt35', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zznsy8ljjsl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zznsy8ljjsl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c9c40l7nhd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c9c40l7nhd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xsti1deqi37').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xsti1deqi37', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tkjk2movgvj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tkjk2movgvj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-whgz3e4kqaq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-whgz3e4kqaq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5e6k4lstuz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5e6k4lstuz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-esgz3cnnp9t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-esgz3cnnp9t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2vk4dbc0xjq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2vk4dbc0xjq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kraz1k911nl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kraz1k911nl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8zfsonz22px').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8zfsonz22px', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zmpc3f4j7o7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zmpc3f4j7o7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gqh72xb0d85').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gqh72xb0d85', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gpnnus2xbns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gpnnus2xbns', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vkdq6rnrgcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vkdq6rnrgcm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eynxfq9jxwb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eynxfq9jxwb', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ikkc8299d2"]=  window.__ectimmers["ecom-ikkc8299d2"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-ikkc8299d2"]["5v1n99hkx"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ikkc8299d2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ikkc8299d2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7kpgvd2k6ao').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7kpgvd2k6ao', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yrikxxije4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yrikxxije4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x0v3vrdfb7b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x0v3vrdfb7b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pvehjzcu1mj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pvehjzcu1mj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z53jfa7dxo8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z53jfa7dxo8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p19pol44oeo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p19pol44oeo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fn1gmji2hzl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fn1gmji2hzl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v7g78xp4yb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v7g78xp4yb', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-m69yzyw0l8h"]=  window.__ectimmers["ecom-m69yzyw0l8h"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-m69yzyw0l8h"]["dt9zd5a85"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-m69yzyw0l8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m69yzyw0l8h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8owd7919a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8owd7919a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xpwows479zr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xpwows479zr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l75gkk7dyib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l75gkk7dyib', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5p5ki2d4jak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5p5ki2d4jak', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-azmmm3leq5t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-azmmm3leq5t', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ra4l589ya6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ra4l589ya6', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-97jv2miixu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-97jv2miixu', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3m2xm2nncx9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3m2xm2nncx9', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wcqunalbl0l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wcqunalbl0l', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u132e17s2kl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u132e17s2kl', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lvtzxcchxy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lvtzxcchxy', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a1m914v4fbc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a1m914v4fbc', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jkvf8khftsh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jkvf8khftsh', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zuqhzxaj4fr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zuqhzxaj4fr', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s67yt0s5wp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s67yt0s5wp', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2gazlbe3gkm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2gazlbe3gkm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vilck724u7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vilck724u7a', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i7m40l7d02k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i7m40l7d02k', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-49sh1t9g35u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-49sh1t9g35u', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zeh8uzocrt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zeh8uzocrt', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h6ay815aq5i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h6ay815aq5i', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}